<template>
  <div class="about">
    <h3>Ethan TATIBOUËT</h3>
    <p>
      Etudiant en 5ème année à l’EPSI Nantes, mes compétences me permettent de concevoir et développer des applications ergonomiques et performantes. J'aime m'ouvrir à de nouveaux horizons tels que la modélisation 3D, la gamification ou bien les systèmes embarqués. En outre, je suis capable de mettre en place des infrastructures réseaux sécurisées.
    </p>
  </div>
</template>

<script>
export default {
  name: 'About'
};
</script>

<style lang="scss" scoped>
.about {
  background-color: var(--blue);
  color: var(--white);
  padding: 20px 30px 100px;

  h3 {
    margin: 0;
  }

  p {
    text-align: justify;
  }
}

@media screen and (min-width: 1024px) {
  .about {
    padding: 30px 80px 150px;
    h3 {
      font-size: 32px;
      margin: 30px auto 40px;
    }
    p {
      margin: auto;
      font-size: 25px;
    }

    h3,
    p {
      width: 80vw;
    }
  }
}
</style>
